export default __webpack_public_path__ + "static/media/Background_00045.48a388c0.png";